import lazyLoad from '../utils/lazyLoad';

const ContractDetail = lazyLoad(import( '../pages/Contracts/ContractDetail'));
const ContractParameters = lazyLoad(import( '../pages/Contracts/parameters/ContractParameters'));
const ContractBuy = lazyLoad(import( '../pages/Contracts/buy/ContractBuy'));

const routesContract = [
  {
    path: '/',
    exact: true,
    component: ContractDetail,
  },
  {
    path: '/parameters',
    exact: true,
    component: ContractParameters,
  },
  {
    path: '/buy',
    exact: true,
    component: ContractBuy,
    fixedFooter: true,
  },
];

export default routesContract;
